import React from 'react'
import MyButton from '../../../../../../UI/form/MyButton'
import { useState } from 'react'
import MyModal from '../../../../../../UI/modal/MyModal'
import SupplyBillPaymentForm from './SupplyBillPaymentForm'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const SupplyBillPaymentButton = ({ supplyBillId, billPayment }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            size='smExtra'
            onClick={e => setOpen(true)}
        >
            {
                // <AddIcon />
                billPayment ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={billPayment ? 'Редагувати оплату' : 'Додати оплату'}
            // header={'Додати оплату'}
            disableClickOutside={true}
            content={
                <SupplyBillPaymentForm
                    supplyBillId={supplyBillId}
                    billPaymentBd={billPayment}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SupplyBillPaymentButton